/* eslint-disable array-callback-return */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from 'react'

import Leaflet from 'leaflet'

import 'leaflet/dist/leaflet.css'

import { notify } from '../../../components/Toast'
import { ToastContainer } from 'react-toastify'

import '../Menu/InternalMenu.scss'

import Logo from '../../../assets/svg/logoEnglish.svg'
import persianLogo from '../../../assets/pictures/persianLogo.png'
import persianDarkLogo from '../../../assets/pictures/persianLogoDark.png'

import iconUrl from '../../../assets/svg/Location.svg'

import { get, post } from '../../../services/https'

import { MapContainer, TileLayer, Marker } from 'react-leaflet'

export const newicon = new Leaflet.Icon({
  iconUrl,
  iconAnchor: [5, 55],
  popupAnchor: [10, -44],
  iconSize: [45, 55]
})

function index() {
  const [table, setTable] = useState([])

  const [name, setName] = useState('')
  const [nameAlert, setNameAlert] = useState(false)

  const [phoneNumber, setPhoneNumber] = useState('')
  const [phoneNumberAlert, setPhoneNumberAlert] = useState(false)

  const [reserveDate, setReserveDate] = useState('')
  const [reserveDateAlert, setReserveDateAlert] = useState(false)

  const [tableNumber, setTableNumber] = useState('')
  const [tableNumberAlert, setTableNumberAlert] = useState(false)

  const [buttonStatus, setButtonStatus] = useState(false)

  const position = [37.251087749085556, 49.943633850293146]
  const Markers = () => {
    return (
      <Marker
        key={position}
        position={position}
        interactive={false} 
        icon={newicon}
      />
    )
  }

  useEffect(() => {
    get('/api/front/table').then(response => {
      setTable(response.data.data)
    }).catch(err => {
      notify('error', 'دریافت اطلاعات با خطا مواجه شد')
    })
  }, [])

  const formHandler = () => {
    if (name.length > 3) {
      setNameAlert(false)
    } else {
      setNameAlert(true)
    }

    if (phoneNumber.length > 10) {
      setPhoneNumberAlert(false)
    } else {
      setPhoneNumberAlert(true)
    }

    if (reserveDate.length > 5) {
      setReserveDateAlert(false)
    } else {
      setReserveDateAlert(true)
    }

    if (tableNumber.length > 3) {
      setTableNumberAlert(false)
    } else {
      setTableNumberAlert(true)
    }

    if (name.length > 3 &&
      phoneNumber.length > 10 &&
      reserveDate.length > 5 &&
      tableNumber.length > 3) {
        post('/api/front/im/reservation', {
          name,
          phoneNumber,
          reserveDate,
          tableNumber,
        }).then(response => {
          if (response.data.success) {
            notify('success', 'فرم رزرو با موفقیت ارسال شد')
            setButtonStatus(true)
          }
        }).catch(error => {
          notify('error', 'دریافت اطلاعات با خطا مواجه شد')
        })
      }
  }
  
  return (
    <div className='InternalMenu'>
      <ToastContainer rtl />
      <div className='countainer'>
        <div className='InternalMenu_logo'>
          <img width={300} src={Logo} alt="Logo" />
        </div>

        <div className="internalMenu_subtitle">
          تبریز کافه بیکری !!
        </div>

        <div className="InternalMenu_category_title">
          فرم رزرو میز 
        </div>

        <div className="InternalMenu_job_countainer">
          <div className="InternalMenu_job_right">
            <div className="InternalMenu_job_title">
              فرم رزرو میز
            </div>
            <div className="InternalMenu_job_sutitle">
              برای رزرو میز در مجموعه مجموعه تبریز کافه بیکری ، لطفا فرم را تکمیل نموده
              و منتظر تماس همکاران ما باشید.
            </div>
            <div className="InternalMenu_job_logo">
              <img src={persianLogo} alt="persianLogo" />
            </div>
            <div className="InternalMenu_job_btn">
              <button onClick={formHandler} style={buttonStatus ? { display: 'none' } : { display: '' }}>
                ثبت اطلاعات
              </button>
            </div>
          </div>
          <div className="InternalMenu_job_form">
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">نام و نام خانوادگی : </label>
                <input type="text" onChange={e => {
                  setName(e.target.value)
                }} />
                <small style={nameAlert ? { display: '' } : { display: 'none' }}>نام خانوادگی صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">شماره تماس : </label>
                <input type="text" onChange={e => {
                  setPhoneNumber(e.target.value)
                }}/>
                <small style={phoneNumberAlert ? { display: '' } : { display: 'none' }}>شماره تماس نیست</small>
              </section>
            </div>
            <div className='InternalMenu_job_form_countainer'>
              <section>
                <label htmlFor="">تاریخ رزرو  : </label>
                <input type="text" onChange={e => {
                  setReserveDate(e.target.value)
                }}/>
                <small style={reserveDateAlert ? { display: '' } : { display: 'none' }}>تاریخ صحیح نیست</small>
              </section>
              <section>
                <label htmlFor="">شماره میز :</label>
                <select name="" id="" onChange={e => setTableNumber(e.target.value)}>
                  <option value="">انتخاب کنید</option>
                  {table ? table.map((item, index) => (
                    <option key={index} value={item.name}>{item.name}</option>
                  )) : ''}
                </select>
                <small style={tableNumberAlert ? { display: '' } : { display: 'none' }}>شماره میز صحیح نیست</small>
              </section>
            </div>
          </div>
        </div>

        <div className='InternalMenu_footer'>
          <div className='InternalMenu_footer_left'>
            <img src={persianDarkLogo} alt="persianDarkLogo" />
            <span className='InternalMenu_footer_left_subtitle'>
              تبریز کافه بیکری !!
            </span>
            <span>
              شماره های تماس :
            </span>
            <span>
              013-42135632 ،  013-42135632
            </span>
            <address>
              آدرس : آستانه اشرفیه ، میدان جمهوری
            </address>
          </div>
          <div className='InternalMenu_footer_center'>
            <span className='InternalMenu_footer_center_title'>
              لینک های دسترسی 
            </span>
            <ul>
              <li><a href="/">منو</a></li>
              <li><a href="/internalMenu/reserve">رزرو میز</a></li>
              <li><a href="/internalMenu/job">استخدام</a></li>
              <li><a href="/internalMenu/faq">سوالات پر تکرار</a></li>
            </ul>
          </div>
          <div className='InternalMenu_footer_right'>
            <MapContainer 
              style={{ width: '350px', height: '300px', margin: '1em 0 0 0' }}
              center={position} 
              zoom={14}
              >
              <TileLayer
                attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.osm.org/{z}/{x}/{y}.png"
              />
              <Markers />
            </MapContainer>
          </div>
        </div>

        <div className="copyright">
          <span>کلیه ی حقوق مادی و معنوی این وبسایت متعلق به مجموعه تبریز کافه بیکری است</span>
          <span>طراحی و توسعه توسط : <a href="https://ham-team.ir">هم تیم</a></span>
        </div>
      </div>
    </div>
  )
}

export default index